import { GET_GROUP_POSTS_START } from "../../types";

export const group_posts = (payload) => ({
  type: GET_GROUP_POSTS_START,
  payload,
});
